import { IReportsColumnsItem } from './types';

export const mockReportColumns: IReportsColumnsItem[] = [
    {
        id: 1111,
        checked: true,
        permanentDisabled: true,
        title: 'Лицевой счет',
    },
    {
        id: 1112,
        checked: true,
        permanentDisabled: true,
        title: 'Абонентский номер',
    },
    {
        id: 1113,
        checked: true,
        permanentDisabled: false,
        title: 'ФИО',
    },
    {
        id: 1114,
        checked: true,
        permanentDisabled: false,
        title: 'Дата подключения номера',
    },
    {
        id: 1115,
        checked: true,
        permanentDisabled: false,
        title: 'Статус номера',
    },
    {
        id: 1116,
        checked: true,
        permanentDisabled: false,
        title: 'Дата последнего изменения статуса',
    },
    {
        id: 1117,
        checked: true,
        permanentDisabled: false,
        title: 'Дополнительный номер',
    },
    {
        id: 1118,
        checked: true,
        permanentDisabled: false,
        title: 'Парметры SIM-карты',
        items: [
            {
                id: 11181,
                checked: true,
                permanentDisabled: false,
                title: 'ICC',
            },
            {
                id: 11182,
                checked: true,
                permanentDisabled: false,
                title: 'PUK1',
            },
            {
                id: 11183,
                checked: true,
                permanentDisabled: false,
                title: 'PUK2',
            },
        ],
    },
    {
        id: 1119,
        checked: true,
        permanentDisabled: false,
        title: 'Тарифный план',
    },
    {
        id: 1120,
        checked: true,
        permanentDisabled: false,
        title: 'Платежи с начала месяца',
    },
    {
        id: 1121,
        checked: true,
        permanentDisabled: false,
        title: 'Начисления с начала месяца',
    },
    {
        id: 1122,
        checked: true,
        permanentDisabled: false,
        title: 'Параметры лимитирования',
        items: [
            {
                id: 11221,
                checked: true,
                permanentDisabled: false,
                title: 'Лимит',
            },
            {
                id: 11222,
                checked: true,
                permanentDisabled: false,
                title: 'Единиа измерения',
            },
            {
                id: 11223,
                checked: true,
                permanentDisabled: false,
                title: 'Порог предупреждения',
            },
            {
                id: 11224,
                checked: true,
                permanentDisabled: false,
                title: 'Правила распределения лимитов',
            },
        ],
    },
];
